import * as React from 'react';

import { Input } from 'components/shadcn';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Combobox,
} from 'components/shadcn';
import { CommandItem } from 'components/shadcn/command';
import { Check } from 'lucide-react';
import { cn } from '../../shadcn';

export const InputControl = React.forwardRef(
  (
    { form, type, label, name, renderOptions = null, options = [], ...props },
    ref,
  ) => {
    let inputElement = null;

    switch (type) {
      case 'autocomplete':
        inputElement = (
          <FormField
            control={form.control}
            name={name}
            render={({ field, fieldState }) => (
              <FormItem>
                <FormLabel htmlFor={name}>
                  {label}
                  {props?.required ? ' *' : ''}
                </FormLabel>
                <Combobox
                  id={name}
                  placeholder={props?.placeholder}
                  value={field.value?.label}
                  disabled={props?.disabled}
                  options={options}
                  renderOptions={(option) =>
                    renderOptions ? (
                      renderOptions(option, field)
                    ) : (
                      <CommandItem
                        value={option?.value}
                        key={option?.value?.toString()}
                        onSelect={(currentValue) => {
                          currentValue === field.value
                            ? form.resetField(name)
                            : field.onChange(option);
                        }}
                      >
                        <div className="flex flex-col">
                          <span className="font-medium">{option.label}</span>
                          <span className="text-xs text-muted-foreground">
                            ID: {option.value} • {option.city}
                            {option.province
                              ? `, ${option.province}`
                              : ''} • {option.timeZone}
                          </span>
                        </div>
                        <Check
                          className={cn(
                            'ml-auto h-4 w-4',
                            option.value === field.value?.value
                              ? 'opacity-100'
                              : 'opacity-0',
                          )}
                        />
                      </CommandItem>
                    )
                  }
                  aria-invalid={fieldState?.error ? 'true' : 'false'}
                />
                <FormMessage />
              </FormItem>
            )}
          />
        );
        break;
      default:
        inputElement = (
          <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
              <FormItem>
                <FormLabel htmlFor={name}>
                  {label}
                  {props?.required ? ' *' : ''}
                </FormLabel>
                <FormControl>
                  <Input
                    id={name}
                    ref={ref}
                    type={type}
                    {...field}
                    {...props}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        );
        break;
    }

    return inputElement;
  },
);

InputControl.displayName = 'InputControl';
